import { Controller } from "@hotwired/stimulus"

// 체험 종료 완료 화면 — "종료 중" 을 잠시 보여준 뒤 결과로 바꾼다.
//
// 서버 처리는 이미 끝난 상태로 도착한다(로그아웃·세션 파기는 리다이렉트 전에 끝난다).
// 즉 이 대기는 실제 작업을 기다리는 것이 아니라 **클릭에 대한 반응을 보여주는 연출**이다.
// 그래서 문구도 데이터가 지금 지워지는 것처럼 읽히지 않게 "종료하는 중" 으로 둔다
// (등록 데이터의 물리 삭제는 만료 +24시간 뒤 배치가 한다 — 설계 D7).
//
// 마크업은 결과가 기본으로 보이도록 되어 있고, 여기서 순서를 뒤집는다.
// 그래야 JS 가 죽은 브라우저에서도 "종료 중입니다" 에 갇히지 않는다.
export default class extends Controller {
  static targets = ["progress", "result"]
  static values = { delay: { type: Number, default: 3000 } }

  connect() {
    this.progressTarget.classList.remove("hidden")
    this.resultTarget.classList.add("hidden")

    this.timer = setTimeout(() => this.reveal(), this.delayValue)
  }

  // Turbo 로 화면을 벗어나면 connect 없이 사라질 수 있다. 타이머를 남기면
  // 이미 없는 요소를 만지며 콘솔 에러를 낸다.
  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  reveal() {
    this.progressTarget.classList.add("hidden")
    this.resultTarget.classList.remove("hidden")
  }
}
